import { styled } from '@mui/material';
import { Box } from '@mui/system';
import FlexBox from 'components/flexbox/FlexBox';
import { H5 } from 'components/Typography';
import { useTranslation } from 'react-i18next'; // styled components
import axiosInstance from 'utils/axios';
import * as FileSaver from 'file-saver';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';

const Wrapper = styled(Box)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
}));
const HeadingArea = () => {
    const { t } = useTranslation();
    const [isDownloading, setIsDownloading] = useState(false);
    const handleDownload = async () => {
        try {
            setIsDownloading(true);
            const { data } = await axiosInstance.get(
                '/api/prv/operator-submissions/final-score/download',
                { responseType: 'blob' },
            );
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            FileSaver.saveAs(blob, 'Final Score.xlsx');
        } catch (error) {
            console.error(error);
        } finally {
            setIsDownloading(false);
        }
    };
    return (
        <Wrapper gap={1}>
            <FlexBox alignItems="center" justifyContent="space-between">
                <H5>{t('Final Score')}</H5>
            </FlexBox>
            <LoadingButton
                variant="contained"
                color="primary"
                loading={isDownloading}
                onClick={handleDownload}
            >
                Download Data
            </LoadingButton>
        </Wrapper>
    );
};

export default HeadingArea;
